module.exports = __webpack_public_path__ + "static/media/lost.4975fcb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/lost.jpg
// module id = 87
// module chunks = 0